

function TimelineItem(props) {
    return (
        <li className="history-timeline__timeline-item">
            <h3>{props.year}</h3>
            
            <ul>
                {props.points.map((point,i) => <li key={i}>{point}</li>)}
            </ul>
        </li>
    )
}

export { TimelineItem }

